var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from "@i18n";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import useIsMobile from "@hooks/useIsMobile";
var ToggleCarCompare = function ToggleCarCompare(_ref) {
  var _ref$labelText = _ref.labelText,
    labelText = _ref$labelText === void 0 ? undefined : _ref$labelText;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useCarCompareContext = useCarCompareContext(),
    toggleCarCompare = _useCarCompareContext.toggleCarCompare,
    bigData = _useCarCompareContext.bigData,
    isAddCarAllowed = _useCarCompareContext.isAddCarAllowed,
    triggerComparisonEvent = _useCarCompareContext.triggerComparisonEvent;
  var isMobile = useIsMobile();
  if (!isAddCarAllowed()) return;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2.5 items-center",
    id: "car-compare"
  }, !isMobile && /*#__PURE__*/React.createElement("strong", {
    className: "text-[#154F9C] text-xs font-bold leading-[24px]"
  }, labelText !== null && labelText !== void 0 ? labelText : t("car_comparison", {
    ns: "web_common"
  })), isMobile && /*#__PURE__*/React.createElement("span", {
    className: "text-[#0e5bc0] text-xs leading-[24px]"
  }, labelText !== null && labelText !== void 0 ? labelText : t("compare", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    id: "compare-toggle-switch",
    className: ["cursor-pointer w-[44px] h-[24px] rounded-[12px] relative", bigData !== null && bigData !== void 0 && bigData.showComparison ? "bg-[#3C56D4]" : "bg-[#D6DFE9]"].join(" "),
    onClick: toggleCarCompare
  }, /*#__PURE__*/React.createElement("span", {
    className: ["bg-white w-[17px] h-[17px] block rounded-full transform transition duration-300 absolute top-[calc(50%-8.5px)] right-[3px]", !(bigData !== null && bigData !== void 0 && bigData.showComparison) ? "translate-x-[-21px]" : undefined].join(" ")
  })));
};
export default ToggleCarCompare;